import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { CustomValidatorsService } from 'src/app/services/custom-validators.service';
import { UserService } from 'src/app/services/user.service';
import { ToastMsg, ToastmsgService } from 'src/app/util/toastmsg/toastmsg.service';

@Component({
  selector: 'app-register-user',
  templateUrl: './register-user.component.html',
  styleUrls: ['./register-user.component.css']
})
export class RegisterUserComponent implements OnInit {
  userRegFg! : FormGroup
  constructor(private fb : FormBuilder, private customValidator : CustomValidatorsService,
    private userService : UserService,private toastMsgService : ToastmsgService, private router : Router) {

  }
  ngOnInit(): void {
    this.userRegFg=this.fb.group({
      "username" :  ['',[Validators.required,Validators.pattern(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)]],
      "displayName" : ['',[Validators.required]],
      "password" : ['',this.customValidator.customPasswordValidator({pattern : "^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$",msg:"Invalid pattern"})],
      "confirmPassword" : ['',this.confirmPasswordValidator()]
    })
  }

  registerUser() {
    this.userService.registerUser(this.userRegFg.value)
      .subscribe({
        next : (res) => {
          if(res.status==200 || res.status==201) {
            this.toastMsgService.setMsg({msg : "User Registered Successfully!",msgTitle : "Success", msgType : "I"});
            this.router.navigate(["/sign-in"]);
          } else {
            const body : any = res.body;
            this.registerUserErrorMsg(res.status,body?.result);
          } 
        },error : (err) => {

          this.registerUserErrorMsg(err.status,err.error);
        }
      }
    )
  }

  registerUserErrorMsg(status : number,msg : string) {
    if(status >=500) {
      this.toastMsgService.setMsg({msg : "Internal Server Error!",msgTitle : "Error", msgType : "E"});
    } else {

      this.toastMsgService.setMsg({msg : msg,msgTitle : "Warning", msgType : "W"});
    } 
  }

  confirmPasswordValidator = (): ValidatorFn => {
    return (control : AbstractControl) : ValidationErrors|null => {
      if(!control.value) {
        return {
          invalidMsg: "Please enter confirm password!"
        };
      }
      const passwordControl=this.userRegFg.controls['password'];
      if(passwordControl.value !=control.value) {
        return {
          invalidMsg: "password mismatch!"
        };
      } else {
        return null;
      }
    };
  }

  getControlErrMsg(control : AbstractControl) {
    return control?.errors?.['invalidMsg']
  }
}
